"use strict"

import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import PropTypes from "prop-types"
import { FormattedMessage, useIntl } from "react-intl"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import { addNewObject } from "../../../Loaders"
import { logToServer } from "../../../ErrorBoundary"

export default function ModalCreateInventoryType(props) {
  const intl = useIntl()
  const [status_submit, setStatusSubmit] = useState(null)
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
  })
  const [formErrors, setFormErrors] = useState({})

  const onChangeValue = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    })
  }

  const onSubmit_create = (event) => {
    event.preventDefault()
    setStatusSubmit(API_STATUS.LOADING)

    addNewObject("/laboratory/inventory/inventory-type/", formValues)
      .then((data) => {
        setStatusSubmit(API_STATUS.SUCCESS)
        props.onSuccess(data)
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setFormErrors(error)
        setStatusSubmit(null)
        alert(intl.formatMessage({ id: "inventory.error-unable-to-create-type" }))
      })
  }

  return (
    <Modal size={"lg"} show={props.show} onHide={props.onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-plus"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"inventory.add-new-inventory-type"} />
          &nbsp;&nbsp;
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          name={"form_create_inventory_type"}
          className={"form-horizontal"}
          onSubmit={onSubmit_create}
          style={{ width: "700px" }}
        >
          <div className={`row one-rem-margin-bottom ${formErrors.name ? "has-error" : ""}`}>
            <span className={"col-sm-1"} />
            <label className={"col-sm-3 col-form-label"}>
              <FormattedMessage id={"general.name"} /> * :
            </label>
            &nbsp;
            <div className={"col-sm-7"}>
              <input
                type={"text"}
                className={"form-control"}
                name={"name"}
                value={formValues.name}
                onChange={onChangeValue}
                required
              />
              <span className={"form-text"}>{formErrors.name}</span>
            </div>
          </div>

          <div className={`row one-rem-margin-bottom ${formErrors.description ? "has-error" : ""}`}>
            <span className={"col-sm-1"} />
            <label className={"col-sm-3 col-form-label"}>
              <FormattedMessage id={"general.description"} /> * :
            </label>
            &nbsp;
            <div className={"col-sm-7"}>
              <input
                type={"text"}
                className={"form-control"}
                name={"description"}
                value={formValues.description}
                onChange={onChangeValue}
                required
              />
              <span className={"form-text"}>{formErrors.description}</span>
            </div>
          </div>

          <div align={"center"}>
            {status_submit === API_STATUS.LOADING && (
              <div>
                <div className="spinner-border text-primary text-center" role="status" />
                &nbsp;
                <FormattedMessage id={"general.saving"} />
                ...
              </div>
            )}
            {status_submit === null && (
              <Button variant={"primary"} type={"submit"}>
                <span className={"fa fa-floppy-o text_white"} />
                &nbsp;
                <FormattedMessage id={"general.save"} />
              </Button>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={"outline-primary"}
          onClick={props.onHide}
          style={{ display: "flex", float: "right" }}
        >
          <FormattedMessage id={"general.closeButton"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ModalCreateInventoryType.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
